import { Box, TextV2 } from '@withjoy/joykit';
import { CheckOutline, Registry as RegistryIcon } from '@withjoy/joykit/icons';
import React from 'react';
import { StyledGiftBasketFloatingWidgetContainer, StyledGiftBasketFloatingWidgetButton, styles } from './GiftBasketFloatingWidget.styles';
import { useShouldShowOnScrollYPosition } from '@shared/utils/hooks/useShouldShowOnScrollYPosition';
import { useTranslation } from '@shared/core';

type GiftBasketFloatingWidgetProps = {
  onTriggerClick: React.MouseEventHandler<HTMLButtonElement>;
  registryItemCount: number;
};

export const GiftBasketFloatingWidget = ({ onTriggerClick, registryItemCount }: GiftBasketFloatingWidgetProps) => {
  const { t } = useTranslation('sharedComponents');
  const { giftCount, checklist } = t('registryGiftBasket', 'floatingWidget');

  const shouldShow = useShouldShowOnScrollYPosition(290);

  return (
    <StyledGiftBasketFloatingWidgetContainer
      __css={styles.giftBasketFloatingWidgetContainer}
      className={shouldShow ? 'is-visible' : undefined}
    >
      <StyledGiftBasketFloatingWidgetButton
        as="button"
        data-tab="checklist"
        onClick={onTriggerClick}
        __css={styles.giftBasketFloatingWidgetButton}
      >
        <Box paddingRight={2}>
          <CheckOutline />
        </Box>
        <TextV2 typographyVariant="hed2">{checklist()}</TextV2>
      </StyledGiftBasketFloatingWidgetButton>
      <StyledGiftBasketFloatingWidgetButton
        as="button"
        data-tab="giftList"
        onClick={onTriggerClick}
        __css={styles.giftBasketFloatingWidgetButton}
      >
        <Box paddingRight={2}>
          <RegistryIcon />
        </Box>
        <TextV2 typographyVariant="hed2">{giftCount({ count: registryItemCount })}</TextV2>
      </StyledGiftBasketFloatingWidgetButton>
    </StyledGiftBasketFloatingWidgetContainer>
  );
};
